import apiClient from '../common/http';

interface LoginResponse {
    accessToken: string;
    refreshToken: string;
}

const EYE_OPEN_SVG = `
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"></path>
    <circle cx="12" cy="12" r="3"></circle>
`;

const EYE_OFF_SVG = `
    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-6.5 0-10-7-10-7a18.45 18.45 0 0 1 4.06-5.06"></path>
    <path d="M9.9 4.24A10.94 10.94 0 0 1 12 4c6.5 0 10 7 10 7a18.5 18.5 0 0 1-3.36 4.32"></path>
    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24"></path>
    <line x1="3" y1="3" x2="21" y2="21"></line>
`;

function setButtonState(button: HTMLButtonElement, label: string, disabled: boolean): void {
    const labelEl = button.querySelector<HTMLElement>('.btn-label');
    if (labelEl) {
        labelEl.textContent = label;
    } else {
        button.textContent = label;
    }
    button.disabled = disabled;
}

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('login-form') as HTMLFormElement | null;
    const messageDiv = document.getElementById('message');
    const loginButton = document.getElementById('login-button') as HTMLButtonElement | null;
    const passwordInput = document.getElementById('password') as HTMLInputElement | null;
    const togglePasswordBtn = document.getElementById('toggle-password') as HTMLButtonElement | null;
    const eyeIcon = document.getElementById('eye-icon') as unknown as SVGElement | null;

    if (togglePasswordBtn && passwordInput && eyeIcon) {
        togglePasswordBtn.addEventListener('click', () => {
            const isHidden = passwordInput.type === 'password';
            passwordInput.type = isHidden ? 'text' : 'password';
            eyeIcon.innerHTML = isHidden ? EYE_OFF_SVG : EYE_OPEN_SVG;
            togglePasswordBtn.setAttribute('aria-label', isHidden ? 'Hide password' : 'Show password');
        });
    }

    if (form && messageDiv && loginButton) {
        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            const email = (document.getElementById('email') as HTMLInputElement).value;
            const password = (document.getElementById('password') as HTMLInputElement).value;

            messageDiv.innerHTML = '';
            setButtonState(loginButton, 'Signing in...', true);

            try {
                const response = await apiClient.post<LoginResponse>('/auth/login', { email, password });

                if (response.succeeded && response.data) {
                    const loginData = response.data;
                    apiClient.setTokens(loginData.accessToken, loginData.refreshToken);
                    window.location.href = '/Home/Index';
                } else {
                    const errorMessage = response.message || response.errors?.[0]?.message || 'Invalid email or password';
                    messageDiv.innerHTML = `<div class="alert alert-danger">${errorMessage}</div>`;
                    setButtonState(loginButton, 'Sign In', false);
                }
            } catch (error: any) {
                let errorMessage = 'An error occurred during login. Please try again.';
                if (error.response && error.response.data) {
                    const errorData = error.response.data;
                    errorMessage = errorData.message || errorData.errors?.[0]?.message || errorMessage;
                }
                messageDiv.innerHTML = `<div class="alert alert-danger">${errorMessage}</div>`;
                setButtonState(loginButton, 'Sign In', false);
            }
        });
    }
});
